import { render, staticRenderFns } from "./GoalListMandalaSection.vue?vue&type=template&id=f7de2fac&scoped=true"
import script from "./GoalListMandalaSection.vue?vue&type=script&lang=js"
export * from "./GoalListMandalaSection.vue?vue&type=script&lang=js"
import style0 from "./GoalListMandalaSection.vue?vue&type=style&index=0&id=f7de2fac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_359e2a22b61d78988ed9bf0e7b495bd0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7de2fac",
  null
  
)

export default component.exports